import React, { useContext } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { StyledWebView } from '../common/StyledWebView';
import PropTypes from 'prop-types';
import ComponentContainer from '../common/ComponentContainer';
import { H1 } from '../text';
import Button from '../common/Button';
import LayoutContext from '../../contexts/Layout';

const STYLED_WEB_VIEW_ID = 'Cta';

const Cta = ({
    buttonText,
    buttonTextColor,
    description,
    descriptionColor,
    firstColor,
    followContentLink,
    secondColor,
    headline,
    headlineColor,
    link,
    references,
    webOnly = false,
    width,
    nodeTypeAlias = 'Cta'
}) => {
    const { layout } = useContext(LayoutContext);
    const isExternal = link?.isExternal;
    const internalKey = link?.internalKey;
    const externalUrl = link?.externalUrl;

    if (!layout.device.os.equals('web') && webOnly) {
        return null;
    }

    if (layout.device.isNative) {
        return (
            <View dataSet={{ umbracoComponentName: nodeTypeAlias }}>
                <LinearGradient colors={[firstColor, secondColor]} style={Styles.gradient} />
                <ComponentContainer>
                    <View style={{ margin: layout.styleGuide.spacer1 }}>
                        <H1 style={{ color: headlineColor, marginBottom: layout.styleGuide.spacer3 }} text={headline} />
                        <StyledWebView textProps={{ style: { color: descriptionColor } }} html={description} nodeId={STYLED_WEB_VIEW_ID} />
                    </View>
                    {!!buttonText && (
                        <Button
                            onPress={async () => await followContentLink(isExternal, internalKey, externalUrl, references)}
                            style={{ borderColor: buttonTextColor, borderWidth: 1, margin: layout.styleGuide.spacer2 }}
                            text={buttonText}
                            textStyle={{ color: buttonTextColor }}
                        />
                    )}
                </ComponentContainer>
            </View>
        );
    } else {
        return (
            <View dataSet={{ umbracoComponentName: nodeTypeAlias }}>
                <View>
                    <LinearGradient colors={[firstColor || '#153d6e', secondColor || '#276abc']} style={Styles.gradient} />
                    <ComponentContainer
                        style={StyleSheet.flatten(Styles.container, {
                            flexDirection: 'row',
                            horizontalMargin: layout.styleGuide.spacer1 * 2,
                            paddingVertical: layout.styleGuide.spacer5,
                            marginBottom: 0
                        })}
                        dataSet={{
                            spacerBottom: `StyleGuide.Spacer5(${layout.styleGuide.spacer5})`,
                            spacerLeft: `StyleGuide.Spacer1*2(${layout.styleGuide.spacer5 * 2})`,
                            spacerRight: `StyleGuide.Spacer1*2(${layout.styleGuide.spacer5 * 2})`,
                            spacerTop: `StyleGuide.Spacer5(${layout.styleGuide.spacer5})`
                        }}
                    >
                        <View style={{ flex: 1 }}>
                            <View style={{ marginBottom: layout.styleGuide.spacer3 }}>
                                <H1 style={{ color: headlineColor || '#000' }} text={headline} />
                            </View>
                            <View>
                                <StyledWebView textProps={{ style: { color: descriptionColor } }} html={description} nodeId={STYLED_WEB_VIEW_ID} width={width} />
                            </View>
                        </View>
                        {!!buttonText && (
                            <Button
                                onPress={async () => await followContentLink(isExternal, internalKey, externalUrl, references)}
                                style={{ backgroundColor: 'transparent', borderColor: buttonTextColor || '#000', padding: 0 }}
                                text={buttonText}
                                textStyle={StyleSheet.flatten(Styles.buttonTitle, { color: buttonTextColor || '#000' })}
                            />
                        )}
                    </ComponentContainer>
                </View>
            </View>
        );
    }
};

const Styles = StyleSheet.create({
    buttonTitle: {
        fontFamily: 'GothamBook',
        fontSize: Platform.OS === 'web' ? '16pt' : 16
    },
    container: {
        alignItems: 'center',
        backgroundColor: 'transparent'
    },
    gradient: {
        position: 'absolute',
        left: 0,
        height: '100%',
        right: 0,
        top: 0,
        zIndex: -1
    },
    wrapper: {
        alignItems: 'center',
        flex: 1,
        flexDirection: 'row'
    }
});

Cta.propTypes = {
    buttonText: PropTypes.string,
    buttonTextColor: PropTypes.string,
    description: PropTypes.string,
    descriptionColor: PropTypes.string,
    firstColor: PropTypes.string,
    headline: PropTypes.string,
    headlineColor: PropTypes.string,
    secondColor: PropTypes.string,
    textColor: PropTypes.string
};

export default Cta;
